import { FieldProps } from '@rjsf/utils';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TextField } from '../../../../ui/components/pure/text-field/text-field.component';

export interface AccessControlCodesFieldContext {
  initialCodes: string[];
  isDeleted?: boolean;
}

export function AccessControlCodesField(props: FieldProps) {
  const codes: string[] = Array.isArray(props.formData) ? props.formData : [];
  const ctx = (props.registry.formContext ?? {}) as AccessControlCodesFieldContext;
  const initialCodes: string[] = ctx.initialCodes ?? [];
  const isDeleted = ctx.isDeleted ?? false;
  const errorSchema = (props.errorSchema ?? {}) as Record<number, { __errors?: string[] }>;

  const update = (next: string[]) => props.onChange(next, props.fieldPathId.path);

  const handleAdd = () => update([...codes, '']);

  const handleRemove = (index: number) => update(codes.filter((_, i) => i !== index));

  const handleChange = (index: number, value: string) => update(codes.map((c, i) => (i === index ? value : c)));

  return (
    <Box style={{ marginLeft: '4px', marginRight: '4px' }}>
      {codes.map((code, index) => {
        const isLocked = isDeleted || (initialCodes.includes(code) && code !== '');
        const hasError = !!errorSchema[index]?.__errors?.length;
        return (
          <Grid
            container
            spacing={1}
            key={index}
            style={{
              border: '1px solid #e0e0e0',
              borderBottom: index === codes.length - 1 ? '1px solid #e0e0e0' : 'none',
              padding: '8px'
            }}
            sx={{
              alignItems: 'center'
            }}
          >
            <Grid size="grow">
              {isLocked ? (
                <Typography variant="body2" style={{ padding: '6px 0' }}>
                  {code}
                </Typography>
              ) : (
                <TextField
                  fullWidth
                  required
                  textFieldVariant="floating"
                  placeholder="Code"
                  value={code}
                  onChange={(e) => handleChange(index, e.target.value)}
                  error={hasError}
                  helperText={hasError ? 'This field is required' : ' '}
                />
              )}
            </Grid>
            {!isDeleted && (
              <Grid style={{ width: 40, display: 'flex', alignItems: 'center' }}>
                <IconButton size="small" onClick={() => handleRemove(index)}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Grid>
            )}
          </Grid>
        );
      })}
      {!isDeleted && (
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleAdd}
          style={{ marginTop: '24px', marginLeft: '-4px' }}
        >
          + Add another
        </Button>
      )}
    </Box>
  );
}
